import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { AtividadeDBService } from '../database/atividade-db.service';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class AtividadeService extends BaseService {
    override classname: string = 'AtividadeService';
    public override route: string = 'atividade';
    
    public override database = Capacitor.isNativePlatform() ? new AtividadeDBService() : new AtividadeDBService();

    public override novo() {
        return {
            checklist: []
        }
    }
}
